import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import ListView from "../../../utils/Custom/listView";
import ListSearchSection from "../../../utils/Custom/ListSearchSection";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { submitSiteDelete } from "../../../utils/commonComponent/delete";
import { AddButton } from "../../../utils/Custom/Button";
import { getPermissions } from "../rbac/hasAccess";

const headers = ["id", "items", "subcategory"];

const fields = [{ value: "items", label: "Items" }, { value: "subcategory", label: "Sub Category" }];

const InspectionItemsMasterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/master/inspectionItems/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("inspectionItems", row.id);

  const [inspectionItemsList, setInspectionItemsList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "items");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };

  const getWhereClause = () => {
    let whereConditions = "";
    const colMap = {
      items: "items",
      subcategory: "subcategory",
    };
    const colName = colMap[searchBy];
    if (colName && searchKey.trim()) {
      whereConditions = `WHERE LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`;
    }

    return whereConditions;
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();
    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)}`;
    }
    return `SELECT * FROM inspectionItems ${whereClause} ORDER BY id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();
    return `SELECT COUNT(*) AS totalRows FROM inspectionItems ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const [ItemList, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);
      setInspectionItemsList(ItemList);
      setTotalRows(countResult?.[0]?.totalRows || 0);
    } catch (error) {
      console.error("Error fetching items data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("items");
    setSearchKey("");
    // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/master/inspectionItems/0"
          label="Add Inspection Items"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        title="Search Inspection Items"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      <ListView
        headers={headers}
        data={inspectionItemsList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true} //enable checkbox
        deleteTableName={"inspectionItems"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default InspectionItemsMasterList;
